import { axios } from '@/api/axios.ts';
import { createQueryKeys } from '@lukemorales/query-key-factory';
import type {
  TAdvisor,
  TAdvisorsParams,
  TCreateAdvisor,
  TGetAdvisorsResponse,
} from './advisors.types.ts';
import type { TUser } from '../auth/auth.types.ts';

export const advisorsApi = {
  getAdvisors: async (params?: TAdvisorsParams) => {
    const response = await axios.get<TGetAdvisorsResponse>('advisors', { params });

    return response.data;
  },
  getAdvisor: async (id: number) => {
    const response = await axios.get<TAdvisor>(`advisors/${id}`);

    return response.data;
  },
  createAdvisor: async (advisor: TCreateAdvisor) => {
    const response = await axios.post<TUser>('advisors', advisor);

    return response.data;
  },
  updateAdvisor: async (payload: { id: number; advisor: Partial<TUser> }) => {
    const { id, advisor } = payload;
    const response = await axios.patch<TUser>(`advisors/${id}`, advisor);

    return response.data;
  },
  deleteAdvisor: async (payload: { id: number }) => {
    const { id } = payload;

    const response = await axios.delete<TAdvisor>(`advisors/${id}`);

    return response.data;
  },
  advisorsForgotPassword: async (id: number) => {
    const response = await axios.post<void>(`advisors/${id}/password/forgot`);

    return response.data;
  },
  advisorsResetPassword: async (id: number, password: string) => {
    const response = await axios.post<void>(`advisors/${id}/password/reset`, password);

    return response.data;
  },
  assignClients: async (payload: { advisorId: number; clients: number[] }) => {
    const { advisorId, clients } = payload;
    const response = await axios.patch<void>(`advisors/${advisorId}/assign-clients`, { clients });

    return response.data;
  },
  unassignClients: async (payload: { advisorId: number; clients: number[] }) => {
    const { advisorId, clients } = payload;
    const response = await axios.patch<void>(`advisors/${advisorId}/unassign-clients`, { clients });

    return response.data;
  },
};

export const advisorsQueries = createQueryKeys('advisors', {
  getAdvisors: (params?: TAdvisorsParams) => ({
    queryKey: ['list', params],
    queryFn: () => advisorsApi.getAdvisors(params),
  }),
  getAdvisor: (id: number) => ({
    queryKey: ['advisor', id],
    queryFn: () => advisorsApi.getAdvisor(id),
  }),
});
